import { render, staticRenderFns } from "./productAccessory.vue?vue&type=template&id=4129d33a&scoped=true&"
import script from "./productAccessory.vue?vue&type=script&lang=js&"
export * from "./productAccessory.vue?vue&type=script&lang=js&"
import style0 from "./productAccessory.vue?vue&type=style&index=0&id=4129d33a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4129d33a",
  null
  
)

export default component.exports